import React from "react";
import StaffTendersMobileTabs from "../staff/responsive/StaffTendersMobileTabs";
import TenderTabs from "../club/TenderTabs";
import { showsSourceTabs } from "../../utils/tenderSourceTabs";
import StaffTenderCard from "../club/StaffTenderCard";
import TenderCard from "../club/TenderCard";
import StaffAppliedPitches from "../stafftender/StaffAppliedPitches";

const CoachTendersMainContent = ({
  isMobile,
  activeMainTab,
  setActiveMainTab,
  setShowFilterModal,
  sortBy,
  handleSortChange,
  searchTerm,
  handleSearchChange,
  activeSubTab,
  setActiveSubTab,
  activePositionFilter,
  handlePositionFilterChange,
  coachInClub,
  canViewPitches,
  isYouthCoach,
  loading,
  error,
  tenders,
  pagination,
  fetchTenders,
  handleSaveStatusChange,
  // Applied tab (self-applications)
  pitches,
  pitchStatus,
  handlePitchStatusChange,
  pitchPagination,
  handlePitchPageChange,
}) => {
  const isAppliedTab = activeMainTab === "applied";
  return (
    <div className=" mx-auto pb-6">
      {/* Sub Tabs. On mobile the strip also hosts the MAIN tabs, so it stays
          mounted on the Applied tab (it hides its browse-only controls
          itself); the desktop category row is browse-only and disappears. */}
      {isMobile ? (
        <StaffTendersMobileTabs
          activeTab={activeMainTab}
          onTabChange={setActiveMainTab}
          onFilterClick={() => setShowFilterModal(true)}
          sortBy={sortBy}
          handleSortChange={handleSortChange}
          searchTerm={searchTerm}
          handleSearchChange={handleSearchChange}
          onSubTabChange={setActiveSubTab}
          activeSubTab={activeSubTab}
          activePositionFilter={activePositionFilter}
          handlePositionFilterChange={handlePositionFilterChange}
          staffInClub={coachInClub}
          canViewPitches={canViewPitches}
          isYouthStaff={isYouthCoach}
          hideTenderTabs={!showsSourceTabs(activeMainTab)}
          /* Self-applicants only: in-club coaches can't pitch themselves, so
             the tab does not exist for them (same rule as the desktop strip
             in CoachTendersHeader). */
          showAppliedTab={!coachInClub}
          /* Jobseekers can only apply to staff-category requests — the
             Players category is not offered to them (BE mirror, see
             club/TenderTabs.js). */
          jobseekerCategories={!coachInClub}
        />
      ) : (
        !isAppliedTab && (
          <TenderTabs
            activeTab={activeSubTab}
            onTabChange={setActiveSubTab}
            isBgWhite={true}
            isFromStaff={true}
            onPositionFilterChange={handlePositionFilterChange}
            activePositionFilter={activePositionFilter}
            /* Youth staff never had TP Lite; on top of that the TP / TP Lite
               switch only means anything on All Listed Requests, because on
               My Requests and Saved every row is of the viewer's own club tier.
               utils/tenderSourceTabs.js holds that rule for every surface. */
            hideTenderTabs={isYouthCoach || !showsSourceTabs(activeMainTab)}
            jobseekerCategories={!coachInClub}
          />
        )
      )}

      {isAppliedTab && (
        <StaffAppliedPitches
          isMobile={isMobile}
          pitches={pitches}
          loading={loading}
          error={error}
          pitchStatus={pitchStatus}
          onStatusChange={handlePitchStatusChange}
          pagination={pitchPagination}
          onPageChange={handlePitchPageChange}
        />
      )}

      {/* Loading State */}
      {!isAppliedTab && loading && (
        <div className="flex justify-center items-center py-8">
          <div className="animate-spin rounded-full h-8 w-8 border-b-2 border-blue-500"></div>
        </div>
      )}

      {/* Error State */}
      {!isAppliedTab && error && (
        <div className="text-red-500 text-center py-8">{error}</div>
      )}

      {/* Tenders Grid */}
      {!isAppliedTab && !loading && !error && (
        <>
          {tenders.length === 0 ? (
            <div className="text-center py-8 text-gray-500">
              {activeMainTab === "saved"
                ? "No saved Requests found"
                : "No Requests found"}
            </div>
          ) : (
            <div
              className={`grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-6 mt-4 md:mt-0 ${
                isMobile ? "px-4" : "px-12"
              }`}
            >
              {/* The template follows the ROW's own tender_category, not the
                  selected pill. On the listed/own tabs both read the same,
                  because the list endpoint scopes the result to the chosen
                  category — but a saved staff request could arrive under the
                  "Players" pill and was drawn as a player card with empty
                  fields. Same discriminator the agent grid already uses
                  (pages/agent/AgentTenders.js:2429). */}
              {tenders.map((tender) =>
                tender.tender_category === "staff" ? (
                  <StaffTenderCard
                    key={tender.id}
                    tender={tender}
                    type={activeMainTab}
                    isFromClub={activeMainTab === "my-tenders"}
                    staffInClub={coachInClub}
                    onSaveStatusChange={handleSaveStatusChange}
                  />
                ) : (
                  <TenderCard
                    key={tender.id}
                    tender={tender}
                    type={activeMainTab}
                    isStaffView={true}
                    staffInClub={coachInClub}
                    onSaveStatusChange={handleSaveStatusChange}
                  />
                )
              )}
            </div>
          )}

          {/* Pagination */}
          {pagination.count > 10 && (
            <div className="flex justify-center items-center gap-2 mt-8">
              <button
                onClick={() => fetchTenders(pagination.currentPage - 1)}
                disabled={!pagination.previous}
                className="px-4 py-2 border rounded-lg disabled:opacity-50 disabled:cursor-not-allowed hover:bg-gray-50"
              >
                Previous
              </button>
              <span className="px-4 py-2">
                Page {pagination.currentPage} of{" "}
                {Math.ceil(pagination.count / 10)}
              </span>
              <button
                onClick={() => fetchTenders(pagination.currentPage + 1)}
                disabled={!pagination.next}
                className="px-4 py-2 border rounded-lg disabled:opacity-50 disabled:cursor-not-allowed hover:bg-gray-50"
              >
                Next
              </button>
            </div>
          )}
        </>
      )}
    </div>
  );
};

export default CoachTendersMainContent;

